import React, { ComponentProps } from 'react';
import A, { AnchorProps } from '@sls-react/components/Links/A';
import qsStringify from '@sls-react/utils/qsStringify';
import { Link } from '@sls-react/routing';
import { ItemState } from '@sls-react/typings/services/rails/item';

type Props = AnchorProps & {
  itemState?: Omit<ItemState, 'available'>;
  page?:
    | 'feedback'
    | 'favorites'
    | 'bumps'
    | 'followers'
    | 'following'
    | 'about';
  saleModal?: boolean;
  username: string | undefined;
};

const LockerLink: React.FC<Props> = ({
  children,
  page,
  itemState,
  saleModal,
  username,
  ...props
}) => {
  const query: any = {};

  if (saleModal) {
    query.sale = 1;
  }

  const stringified = qsStringify(query);

  let as = `/${username}`;
  let href = '/[username]';

  if (page) {
    href += `/${page}`;
    as += `/${page}`;
  }

  if (itemState) {
    href += '/[itemState]';
    as += `/${itemState}`;
  }

  as += stringified;
  href += stringified;

  return (
    <Link href={href} as={as} passHref>
      <a {...props} rel="nofollow noindex">
        {children}
      </a>
    </Link>
  );
};

export default LockerLink;
